
import * as actions from './actions'
import reducer from './reducer'
import PerfilForm from './components/PerfilForm'
import * as TypeAction from './actionTypes'
import AccountCircle from '@material-ui/icons/AccountCircle';

const config = {
    route: {
        path: '/PerfilUser',
        exact: true,
        component: PerfilForm,
    },
    menu: {
        nome: "Meu Perfil",
        rota: '/PerfilUser',
        icone: AccountCircle ,
        ordem: 9999
    },
    reducerConfig: { nome: "PerfilUserReducer", reducer: reducer }

}

export default config

export { actions, reducer, PerfilForm, TypeAction }




// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/index.js